<div class="container">
  <h2>Event Request Form</h2>
  <!-- Pinned Buttons -->
  <div class="pinned-buttons pinned-buttons-row" [class.pinned-buttons-offset]="showStickyRequestTitle" *ngIf="!eventForm.get('requestType')?.invalid && (!pastSubmitted && isEditing) && canEdit">
    <button type="button" class="btn btn-secondary" (click)="saveForLater()">Save for Later</button>
    <button type="submit" class="btn btn-primary" (click)="onSubmit()">Submit</button>
    <button type="delete" class="btn btn-primary" (click)="onDelete()">Delete</button>
  </div>
  <div class="pinned-buttons" [class.pinned-buttons-offset]="showStickyRequestTitle" *ngIf="!eventForm.get('requestType')?.invalid && pastSubmitted && canEdit">
    <div class="pinned-buttons-row">
      <button type="delete" class="btn btn-primary" *ngIf="eventForm.get('requestType')?.value == 'Holiday/Vacation/Internal Testing' && user.isAdmin" (click)="onDelete()">Delete</button>
      <!-- <button type="button" class="btn btn-secondary" (click)="!creatingNewEvent" *ngIf="">Versioning</button> -->
      <button type="button" class="btn btn-secondary" (click)="clone()" *ngIf="!creatingNewEvent">Clone</button>
      <button type="button" class="btn btn-secondary" (click)="enableAllFields()" *ngIf="!isEditing">Edit</button>
      <button type="button" class="btn btn-secondary" (click)="copySummary()" *ngIf="!isEditing && user.isAdmin">Copy Summary</button>
      <button type="button" class="btn btn-warning" (click)="cancelChanges()" *ngIf="isEditing">{{ compareForms()? 'Close Edit' : 'Cancel Changes'}}</button>
      <!-- Is Editing view below -->
      <button type="button" class="btn btn-secondary" (click)="sendToSchedule()" *ngIf="isEditing && user.isAdmin && eventForm.get('requestStatus')?.value != 'Completed'  && eventForm.get('requestStatus')?.value != 'Canceled'">Send To Schedule</button>
      <button type="button" class="btn btn-secondary" (click)="approveEvent()" *ngIf="isEditing && user.isAdmin && eventForm.get('requestStatus')?.value != 'Completed'  && eventForm.get('requestStatus')?.value != 'Canceled'">Approve</button>
      <button type="button" class="btn btn-secondary" (click)="sendEventLink()" *ngIf="isEditing && user.isAdmin && eventForm.get('requestStatus')?.value != 'Completed'  && eventForm.get('requestStatus')?.value != 'Canceled'">Send Event Links</button>
      <button type="button" class="btn btn-secondary" (click)="completeEvent()" *ngIf="isEditing && user.isAdmin && eventForm.get('requestStatus')?.value != 'Completed'  && eventForm.get('requestStatus')?.value != 'Canceled'">Complete Event</button>
      <button type="button" class="btn btn-secondary" (click)="cancelEvent()" *ngIf="isEditing && user.isAdmin && eventForm.get('requestStatus')?.value != 'Completed'  && eventForm.get('requestStatus')?.value != 'Canceled'">Cancel Event</button>
    </div>
    <div class="pinned-buttons-row">
      <button type="submit" class="btn btn-primary second-row" (click)="onSubmit()" *ngIf="isEditing && !compareForms()">Save Changes</button>
      <button *ngIf="pastSubmitted && eventId && user.isAdmin"
              type="button"
              class="btn btn-outline-info"
              (click)="openVersionHistory()"
              [disabled]="isLoading"
              matTooltip="View change history"
              aria-label="View version history for this event">Version History</button>
    </div>
  </div>
  <div class="sticky-request-title" *ngIf="showStickyRequestTitle">
    <span class="sticky-request-title-label">Request Title:</span>
    <span class="sticky-request-title-value">
      {{ eventForm.get('requestTitle')?.value || 'No title yet' }}
    </span>
  </div>
  <form [formGroup]="eventForm" (ngSubmit)="onSubmit()">
    <!-- Spinner Overlay -->
     <!-- TODO:  Should this spinner be the only thing visible when it IS visible? -->
    <div *ngIf="isLoading" class="spinner-overlay">
      <div class="spinner-container">
        <p>{{ spinnerMessage }}</p>
        <mat-spinner></mat-spinner>
      </div>
    </div>

    <!-- Request Type -->
    <div class="form-group" *ngIf="!pastSubmitted">
      <label class="form-label">Request Type *</label>
      <div class="input-column">
        <mat-radio-group formControlName="requestType">
          <div class="radio-with-desc">
          <mat-radio-button value="Live Event">
            Live Event
          </mat-radio-button>
          <div class="radio-desc">
            Live events may include Town Halls, All People Meetings, Fireside Chats, Panel Discussions that will be viewed as it's happening.
          </div>
        </div>
        <div class="radio-with-desc">
          <mat-radio-button value="Recording">
            Recording
          </mat-radio-button>
          <div class="radio-desc">
            Recordings may include Announcements, messages, Fireside Chats, Panel Discussion that will be edited, posted and made available for a future date.
          </div>
        </div>
        <div class="radio-with-desc">
          <mat-radio-button value="Special Request">
            Special Request
          </mat-radio-button>
          <div class="radio-desc">
            Select this option if this is for Video editing, Site visit, or anything besides a Live event or Recording. If Moderated Audio call only, select Special Request.
          </div>
        </div>
        <div class="radio-with-desc" *ngIf="user.isAdmin">
          <mat-radio-button value="Holiday/Vacation/Internal Testing">
            Holiday/Vacation/Internal Testing
          </mat-radio-button>
          <div class="radio-desc">
            Only will be shown for Broadcast team, or "Admins" as we call them.
          </div>
        </div>
        
        </mat-radio-group>
        <div *ngIf="(eventForm.get('requestType')?.invalid && eventForm.get('requestType')?.touched) || missingFields.includes('Request Type')" class="text-error">
          Request Type is required.
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="pastSubmitted">
      <label class="form-label">Request Type</label>
      <div class="input-column">
        {{ eventForm.get('requestType')?.value }}
      </div>
    </div>

    <div class="form-group" *ngIf="pastSubmitted">
      <label class="form-label">Workflow Status</label>
      <div class="input-column">
        {{ eventForm.get('workflow')?.value }}
      </div>
    </div>

    <div class="form-group" *ngIf="pastSubmitted">
      <label class="form-label">Event ID</label>
      <div class="input-column">
        {{ eventForm.get('event_id')?.value }}
      </div>
    </div>

    <!-- Event Ownership Transferred -->
    <div class="form-group" *ngIf="eventForm.get('eventOwnershipTransferred')?.value == 'Yes'">
      <label class="form-label">Event Ownership Transferred</label>
      <div class="input-column">
        {{ eventForm.get('eventOwnershipTransferred')?.value }}
      </div>
    </div>

    <!-- Request Title -->
    <div class="form-group" *ngIf="!eventForm.get('requestType')?.invalid" #requestTitleSection>
      <label for="requestTitle" class="form-label">Request Title *</label>
      <div class="input-column">
        <!-- <mat-form-field class="form-control"> -->
          <input type="text" id="requestTitle" formControlName="requestTitle" class="input-field form-control" placeholder="Enter request title" />
        <!-- </mat-form-field> -->
        <div class="more-info">Enter full title of event or recording. This is the name that will be used for GM Video and Teams invites.</div>
        <div *ngIf="(eventForm.get('requestTitle')?.invalid && eventForm.get('requestTitle')?.touched) || missingFields.includes('Request Title')" class="text-error">
          Request Title is required.
        </div>
      </div>
    </div>

    <!-- Expected Number of Participants -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event'">
      <label for="expectedNumberOfParticipants" class="form-label">Expected Number of Participants *</label>
      <div class="input-column">
        <input type="number" id="expectedNumberOfParticipants" formControlName="expectedNumberOfParticipants"
          class="input-field number form-control" (change)="checkParticipantCount()"/>
        <div class="more-info">
          If under 1000, Please consider using Teams. We can help you organize your
          event. Include in-person and virtual.
        </div>
        <div *ngIf="(eventForm.get('expectedNumberOfParticipants')?.invalid && eventForm.get('expectedNumberOfParticipants')?.touched) || missingFields.includes('Expected Number of Participants')" class="text-error">
          Expected Number of Participants is required.
        </div>
      </div>
    </div>

    <!-- Event Start and End -->
    <div class="form-group" *ngIf="!eventForm.get('requestType')?.invalid">
  <label for="eventStartDate" class="form-label">Event Date/Time * </label>
      <div class="input-column">
        <!-- All-day toggle for Holiday/Vacation/Internal Testing requests -->
        <div class="time-dropdown-row" *ngIf="eventForm.get('requestType')?.value == 'Holiday/Vacation/Internal Testing' && (!pastSubmitted || user.isAdmin)">
          <mat-checkbox formControlName="isAllDay" (change)="onAllDayToggle()">
            All day
          </mat-checkbox>
        </div>
        <!-- Event Start Date and Time -->
        <div class="timedate-row">
          <div class="startend-text">
            Start
          </div>
          <div *ngIf="pastSubmitted && !user.isAdmin">
            {{ eventForm.get('eventStartDate')?.value | date:'short' }} <span class="tz-inline">ET</span>
          </div>
          <div class="date-row" *ngIf="!pastSubmitted || user.isAdmin">
            <input [matDatepicker]="startDatePicker" [min]="today" id="eventStartDate" formControlName="eventStartDate" class="input-field" (dateChange)="onDateChange()" />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </div>
          <div class="time-dropdown-row" *ngIf="(!pastSubmitted || user.isAdmin) && !(eventForm.get('isAllDay')?.value && eventForm.get('requestType')?.value == 'Holiday/Vacation/Internal Testing')">
            <!-- Hour select -->
            <select formControlName="startHour" class="form-control input-field input-field-select time-dropdown" (change)="onTimeChange()">
              <option value="" disabled selected>Select hour</option>
              <option *ngFor="let h of hourOptions" [value]="h.value">{{ h.label }}</option>
            </select>

            <select formControlName="startMinute" class="form-control input-field input-field-select time-dropdown" (change)="onTimeChange()">
              <option value="" disabled selected>Select minute</option>
              <option *ngFor="let minute of minuteOptions" [value]="minute">{{minute}}</option>
            </select>
          </div>
        </div>
        
        <!-- Event End Date and Time -->
        <div class="timedate-row">
          <div class="startend-text">
            End
          </div>
          <div *ngIf="pastSubmitted && !user.isAdmin">
            {{ eventForm.get('eventEndDate')?.value | date:'short' }} <span class="tz-inline">ET</span>
          </div>
          <div class="date-row"  *ngIf="!pastSubmitted || user.isAdmin">
            <input matInput [matDatepicker]="endDatePicker" [min]="this.eventForm.get('eventStartDate')?.value || today " id="eventEndDate" formControlName="eventEndDate" class="input-field" (dateChange)="onDateChange()" />
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </div>
          <div class="time-dropdown-row"  *ngIf="(!pastSubmitted || user.isAdmin) && !(eventForm.get('isAllDay')?.value && eventForm.get('requestType')?.value == 'Holiday/Vacation/Internal Testing')">
            <!-- Hour select -->
            <select formControlName="endHour" class="form-control input-field input-field-select time-dropdown" (change)="onTimeChange()">
              <option value="" disabled selected>Select hour</option>
              <option *ngFor="let h of hourOptions" [value]="h.value">{{ h.label }}</option>
            </select>
            
            <select formControlName="endMinute" class="form-control input-field input-field-select time-dropdown" (change)="onTimeChange()">
              <option value="" disabled selected>Select minute</option>
              <option *ngFor="let minute of minuteOptions" [value]="minute">{{minute}}</option>
            </select>
          </div>
        </div>
        <div class="more-info">
          Day and time (Eastern Time / ET) of the live event/recording session. Enter the actual time. Do not include any buffers.
        </div>
        <div *ngIf="(eventForm.get('eventStartDate')?.invalid && eventForm.get('eventStartDate')?.touched)
        || missingFields.includes('Event Start Date') || missingFields.includes('Start Hour') || missingFields.includes('Start Minute') || missingFields.includes('Start AM/PM')
        " class="text-error">
          Start Date is required.
        </div>
        <div *ngIf="(eventForm.get('eventEndDate')?.invalid && eventForm.get('eventEndDate')?.touched) 
        || missingFields.includes('Event End Date') || missingFields.includes('End Hour') || missingFields.includes('End Minute') || missingFields.includes('End AM/PM')
        " class="text-error">
          End Date is required.
        </div>
      </div>
    </div>

    <!-- Primary Presenting Location -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event'">
      <label *ngIf="eventForm.get('requestType')?.value == 'Live Event'" for="primaryPresentingLocation" class="form-label">Primary Presenting Location *</label>
      <div class="input-column">
        <select formControlName="primaryPresentingLocation" class="form-control input-field input-field-select" (change)="onPrimaryLocationChange($event)">
          <option *ngFor="let location of primaryPresentingLocations" [value]="location">
            {{ location }}
          </option>
          <option value="I don't see my location">I don't see my location</option>
        </select>
        <div *ngIf="eventForm.get('SpecifyYouOwnValuePresentingLocation')?.value">
          <input matInput type="text" placeholder="Enter custom location" 
                formControlName="otherLocation" class="form-control input-field"/>
        </div>
        <div class="more-info">Requestor must make arrangements to secure venue. If using TEAMS only, please select
          Virtual.</div>
        <div *ngIf="(eventForm.get('primaryPresentingLocation')?.invalid && eventForm.get('primaryPresentingLocation')?.touched) || missingFields.includes('Primary Presenting Location')" class="text-error">
          Location is required.
        </div>
      </div>
    </div>

    <!-- Recording Location -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Recording'">
      <label for="recordingLocation" class="form-label">Recording Location *</label>
      <div class="input-column">
        <select formControlName="recordingLocation" class="form-control input-field input-field-select"  (change)="onRecordingLocationChange($event)">
          <option *ngFor="let location of primaryPresentingLocations" [value]="location">
            {{ location }}
          </option>
          <option value="I don't see my location">I don't see my location</option>
        </select>
        <div *ngIf="eventForm.get('SpecifyYourOwnValueRecordingLocation')?.value">
          <input matInput type="text" placeholder="Enter custom location" 
                formControlName="otherRecordingLocation" class="form-control input-field"/>
        </div>
        <div class="more-info">Select Virtual if using Teams. Select I don't see my location if desired location is not listed</div>
        <div *ngIf="(eventForm.get('recordingLocation')?.invalid && eventForm.get('recordingLocation')?.touched) || missingFields.includes('Recording Location')" class="text-error">
          Recording Location is required.
        </div>
      </div>
    </div>

    <!-- Additional Details For Location -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Recording'">
      <label for="additionalDetailsForLocation" class="form-label">Additional Details For Location</label>
      <div class="input-column">
        
        <textarea matInput id="additionalDetailsForLocation" style="height: auto;" formControlName="additionalDetailsForLocation" rows="2"
          class="form-control input-field" placeholder="Enter additional details for location"></textarea>
        <div class="more-info">If event is in Studio or an offsite venue, enter anything we might need to know. Monitors, backgrounds, Props, Teleprompter.</div>
      </div>
    </div>

    <!-- Remote Presenting Location -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event'">
      <label for="remotePresentingLocation" class="form-label">Remote Presenting Location</label>
      <div class="input-column">
        <!-- <mat-form-field appearance="fill" class="form-control"> -->
          <input matInput type="text" id="remotePresentingLocation" formControlName="remotePresentingLocation" class="form-control input-field"
            placeholder="Enter remote presenting location" />
        <!-- </mat-form-field> -->
        <div class="more-info">Enter other locations, such as VC rooms, studio, theater, Teams. Enter as needed.</div>
      </div>
    </div>

    <!-- Requestor Field -->
    <div class="form-group" *ngIf="!eventForm.get('requestType')?.invalid">
      <label for="requestor" class="form-label">Requestor *</label>
      <div class="input-column">
        <!-- Conditionally display the input field or the hyperlink -->
        <ng-container *ngIf="!isRequestorLinkVisible; else requestorLinkTemplate">
          <input matInput type="text" id="requestor" formControlName="requestor" class="form-control input-field"
            (input)="onRequestorInputChange()" (keydown.enter)="onRequestorEnter($event)" (blur)="onRequestorBlur()" placeholder="Enter requestor's name" />
          <div class="more-info">
            Enter the primary event contacts name or email and press Enter to search.
          </div>
        </ng-container>

        <!-- Template for the hyperlink -->
        <ng-template #requestorLinkTemplate>
          <div class="person-link-block">
            <div class="requestor-link-container">
              <img *ngIf="requestorPicture" [src]="requestorPicture" alt="Requestor Picture" class="requestor-picture"/>
              <a [href]="requestorLink" target="_blank">{{ requestorName || eventForm.get('requestor')?.value }}</a>
              <button *ngIf="isEditing" type="button" class="btn btn-link clear-button" (click)="clearRequestor()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <ng-container *ngIf="eventForm.get('requestor')?.value as requestorEmail">
              <div class="person-email" *ngIf="requestorEmail && requestorName && requestorEmail !== requestorName">
                {{ requestorEmail }}
              </div>
            </ng-container>
          </div>
        </ng-template>

        <!-- Validation error message -->
        <div *ngIf="(eventForm.get('requestor')?.invalid && eventForm.get('requestor')?.touched ) || missingFields.includes('Requestor')" class="text-error">
          Requestor is required.
        </div>
        <div *ngIf="eventForm.get('requestor')?.hasError('selectionRequired')" class="text-error">
          Please select a requestor from the search results.
        </div>
        <div *ngIf="eventForm.get('requestor')?.hasError('noMatch')" class="text-error">
          No matching requestor found. Try a different name or email.
        </div>
      </div>
    </div>

    <!-- Event Leader Field -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event' || eventForm.get('requestType')?.value == 'Recording' || eventForm.get('requestType')?.value == 'Special Request'">
      <label for="eventLeader" class="form-label">Event Leader *</label>
      <div class="input-column">
        <!-- Conditionally display the input field or the hyperlink -->
        <ng-container *ngIf="!isEventLeaderLinkVisible; else eventLeaderLinkTemplate">
          <input matInput type="text" id="eventLeader" formControlName="eventLeader" class="form-control input-field"
            (input)="onEventLeaderInputChange()" (keydown.enter)="onEventLeaderEnter($event)" (blur)="onEventLeaderBlur()" placeholder="Enter event leader's name" />
          <div class="more-info">
            Who is the Organization Leader for this request. Type name or email and press Enter to search.
          </div>
        </ng-container>

        <!-- Template for the hyperlink -->
        <ng-template #eventLeaderLinkTemplate>
          <div class="person-link-block">
            <div class="requestor-link-container">
              <a [href]="eventLeaderLink" target="_blank">{{ eventLeaderName || eventForm.get('eventLeader')?.value }}</a>
              <button *ngIf="isEditing" type="button" class="btn btn-link clear-button" (click)="clearEventLeader()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <ng-container *ngIf="eventForm.get('eventLeader')?.value as eventLeaderEmail">
              <div class="person-email" *ngIf="eventLeaderEmail && eventLeaderName && eventLeaderEmail !== eventLeaderName">
                {{ eventLeaderEmail }}
              </div>
            </ng-container>
          </div>
        </ng-template>

        <!-- Validation error message -->
        <div *ngIf="(eventForm.get('eventLeader')?.invalid && eventForm.get('eventLeader')?.touched) || missingFields.includes('Event Leader')" class="text-error">
          Event Leader is required.
        </div>
        <div *ngIf="eventForm.get('eventLeader')?.hasError('selectionRequired')" class="text-error">
          Please select an event leader from the search results.
        </div>
        <div *ngIf="eventForm.get('eventLeader')?.hasError('noMatch')" class="text-error">
          No matching event leader found. Try a different name or email.
        </div>
      </div>
    </div>

    <!-- Responsible For Editing -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Recording'">
      <label for="responsibleForEditing" class="form-label">Responsible For Editing</label>
      <div class="input-column">
        <div class="checkbox-grid" [class.checkbox-grid--two-col]="getOptionEntries(responsibleForEditingOptions).length > 3">
          <mat-checkbox *ngFor="let option of getOptionEntries(responsibleForEditingOptions); trackBy: trackByOptionKey"
                        [formControlName]="option.key"
                        (change)="updateMultiField(responsibleForEditingOptions, 'responsibleForEditing', 'SpecifyYourOwnValueResponsibleForEditing', 'responsibleForEditingOther')">
            {{ option.value }}
          </mat-checkbox>
        </div>
        <div><mat-checkbox formControlName="SpecifyYourOwnValueResponsibleForEditing" (change)="updateMultiField(responsibleForEditingOptions, 'responsibleForEditing', 'SpecifyYourOwnValueResponsibleForEditing', 'responsibleForEditingOther')">Specify Your Own Value</mat-checkbox></div>
        <div *ngIf="eventForm.get('SpecifyYourOwnValueResponsibleForEditing')?.value">
          <input matInput type="text" id="responsibleForEditingOther" formControlName="responsibleForEditingOther" 
                class="form-control input-field" placeholder="Specify your own responsible for editing" (input)="updateMultiField(responsibleForEditingOptions, 'responsibleForEditing', 'SpecifyYourOwnValueResponsibleForEditing', 'responsibleForEditingOther')"/>
        </div>
        <div class="more-info">
          Will Broadcast Services team edit this recording or will it be done by others, Select one.
        </div>
      </div>
    </div>

    <!-- Video Sharing Platforms -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Recording'">
      <label for="videoSharingPlatforms" class="form-label">Video Sharing Platforms *</label>
      <div class="input-column">
        <div class="checkbox-grid" [class.checkbox-grid--two-col]="getOptionEntries(videoSharingPlatformOptions).length > 3">
          <mat-checkbox *ngFor="let option of getOptionEntries(videoSharingPlatformOptions); trackBy: trackByOptionKey"
                        [formControlName]="option.key"
                        (change)="updateMultiField(videoSharingPlatformOptions, 'videoSharingPlatforms', 'SpecifyYourOwnValueVideoSharingPlatforms', 'videoSharingPlatformsOther')">
            {{ option.value }}
          </mat-checkbox>
        </div>
        <div><mat-checkbox formControlName="SpecifyYourOwnValueVideoSharingPlatforms" (change)="updateMultiField(videoSharingPlatformOptions, 'videoSharingPlatforms', 'SpecifyYourOwnValueVideoSharingPlatforms', 'videoSharingPlatformsOther')">Specify Your Own Value</mat-checkbox></div>
        <div *ngIf="eventForm.get('SpecifyYourOwnValueVideoSharingPlatforms')?.value">
          <input matInput type="text" id="videoSharingPlatformsOther" formControlName="videoSharingPlatformsOther" 
                class="form-control input-field" placeholder="Specify your own video sharing platform" (input)="updateMultiField(videoSharingPlatformOptions, 'videoSharingPlatforms', 'SpecifyYourOwnValueVideoSharingPlatforms', 'videoSharingPlatformsOther')"/>
        </div>
        <div class="more-info">
          Where will this video be posted, do you need an MP4 file, select all that apply.  Kaltura is now called GM Video
        </div>
        <div *ngIf="(eventForm.get('videoSharingPlatforms')?.invalid && eventForm.get('videoSharingPlatforms')?.touched) || missingFields.includes('Video Sharing Platforms')" class="text-error">
          Video Sharing Platforms are required.
        </div>
      </div>
    </div>

    <!-- Video File Recipient -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Recording'">
      <label for="videoFileRecipient" class="form-label">Video File Recipient</label>
      <div class="input-column">
        <!-- <mat-form-field appearance="fill" class="form-control"> -->
          <input matInput type="text" id="videoFileRecipient" formControlName="videoFileRecipient" class="form-control input-field"
            placeholder="Enter video file recipient" />
        <!-- </mat-form-field> -->
        <div class="more-info">
          Enter email of Recipient
        </div>
      </div>
    </div>

    <!-- Event Requirements -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event'">
      <label for="eventRequirements" class="form-label">Event Requirements *</label>
      <div class="input-column">
        <div class="checkbox-grid" [class.checkbox-grid--two-col]="getOptionEntries(requirementOptions).length > 3">
          <mat-checkbox *ngFor="let option of getOptionEntries(requirementOptions); trackBy: trackByOptionKey"
                        [formControlName]="option.key"
                        (change)="updateMultiField(requirementOptions, 'eventRequirements')">
            {{ option.value }}
          </mat-checkbox>
        </div>
        <div class="more-info">
          REMEMBER: No copyrighted material is allowed.  Select all that apply (Select Screen Sharing for live demos or if using a 3rd party Polling app)
        </div>
        <div *ngIf="(eventForm.get('eventRequirements')?.invalid && eventForm.get('eventRequirements')?.touched) || missingFields.includes('Event Requirements')" class="text-error">
          Event Requirements are required.
        </div>
      </div>
    </div>

    <!-- Set Items -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event'">
      <label for="setItems" class="form-label">Set Items</label>
      <div class="input-column">
        <!-- <mat-form-field appearance="fill" class="form-control"> -->
          <input matInput type="text" id="setItems" formControlName="setItems" class="form-control input-field"
            placeholder="Enter set items" />
        <!-- </mat-form-field> -->
        <div class="more-info">
          Enter only if event is in our  Studio or remote venue. Items such as: Chairs, tables, monitors, timer, backgrounds, etc.
        </div>
      </div>
    </div>

    <!-- Event Description -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event' || eventForm.get('requestType')?.value == 'Special Request' || eventForm.get('requestType')?.value == 'Holiday/Vacation/Internal Testing'">
      <label for="eventDescription" class="form-label">Event Description</label>
      <div class="input-column">
        <!-- <mat-form-field appearance="fill" class="form-control"> -->
          <textarea matInput id="eventDescription" style="height: auto;" formControlName="eventDescription" class="form-control input-field" rows="4"
            placeholder="Enter event description"></textarea>
        <!-- </mat-form-field> -->
        <div class="more-info">
          Provide an over all description of your event and/or any special requests.  Leave out any embargoed information. Include alternate dates and time in case requested date/time is not available.  
        </div>
      </div>
    </div>

    <!-- Presenters -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event'">
      <label for="presenters" class="form-label">Presenters</label>
      <div class="input-column">
        <!-- <mat-form-field appearance="fill" class="form-control"> -->
          <input matInput type="number" id="presenters" formControlName="presenters" class="form-control input-field number" />
        <!-- </mat-form-field> -->
        <div class="more-info">
          How many people will be presenting in this event
        </div>
      </div>
    </div>

    <!-- Audience -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event'">
      <label class="form-label">Audience *</label>
      <div class="input-column">
          <div class="checkbox-grid" [class.checkbox-grid--two-col]="getOptionEntries(audienceOptions).length > 3">
            <mat-checkbox *ngFor="let option of getOptionEntries(audienceOptions); trackBy: trackByOptionKey"
                          [formControlName]="option.key"
                          (change)="updateMultiField(audienceOptions, 'audience', 'audSpecifyYourOwnValue', 'audienceOther')">
              {{ option.value }}
            </mat-checkbox>
          </div>
          <div><mat-checkbox formControlName="audSpecifyYourOwnValue" (change)="updateMultiField(audienceOptions, 'audience', 'audSpecifyYourOwnValue', 'audienceOther')">Specify Your Own Value</mat-checkbox></div>
          <div *ngIf="eventForm.get('audSpecifyYourOwnValue')?.value">
            <input matInput type="text" id="audienceOther" formControlName="audienceOther" 
                  class="form-control input-field" placeholder="Specify your own audience" (input)="updateMultiField(audienceOptions, 'audience', 'audSpecifyYourOwnValue', 'audienceOther')"/>
          </div>
          <div class="more-info">Who are the participants? Check all that apply.</div>
          <div *ngIf="(eventForm.get('audience')?.invalid && eventForm.get('audience')?.touched) || missingFields.includes('Audience')" class="text-error">
            Audience is required.
          </div>
      </div>
    </div>

    <!-- Region -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event' || eventForm.get('requestType')?.value == 'Recording'">
      <label class="form-label">Region *</label>
      <div class="input-column">
        <div class="checkbox-grid" [class.checkbox-grid--two-col]="getOptionEntries(regionOptions).length > 3">
          <mat-checkbox *ngFor="let option of getOptionEntries(regionOptions); trackBy: trackByOptionKey"
                        [formControlName]="option.key"
                        (change)="updateMultiField(regionOptions, 'region')">
            {{ option.value }}
          </mat-checkbox>
        </div>
        <div class="more-info">Check all that apply.</div>
        <div *ngIf="(eventForm.get('region')?.invalid && eventForm.get('region')?.touched) || missingFields.includes('Region')" class="text-error">
          Region is required.
        </div>
      </div>
    </div>

    <!-- How Will You Take Questions -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event'">
      <label class="form-label">How Will You Take Questions *</label>
      <div class="input-column">
        <div class="checkbox-grid" [class.checkbox-grid--two-col]="getOptionEntries(howTakeQuestionOptions).length > 3">
          <mat-checkbox *ngFor="let option of getOptionEntries(howTakeQuestionOptions); trackBy: trackByOptionKey"
                        [formControlName]="option.key"
                        (change)="updateMultiField(howTakeQuestionOptions, 'takeQuestions', 'SpecifyYourOwnValueQuestions', 'takeQuestionsOther')">
            {{ option.value }}
          </mat-checkbox>
        </div>
        <div><mat-checkbox formControlName="SpecifyYourOwnValueQuestions" (change)="updateMultiField(howTakeQuestionOptions, 'takeQuestions', 'SpecifyYourOwnValueQuestions', 'takeQuestionsOther')">Specify Your Own Value</mat-checkbox></div>
        <div *ngIf="eventForm.get('SpecifyYourOwnValueQuestions')?.value">
          <input matInput type="text" placeholder="Enter custom question method" 
                formControlName="takeQuestionsOther" class="form-control input-field" (input)="updateMultiField(howTakeQuestionOptions, 'takeQuestions', 'SpecifyYourOwnValueQuestions', 'takeQuestionsOther')"/>
        </div>
        <div class="more-info">Check all that apply.</div>
        <div *ngIf="(eventForm.get('takeQuestions')?.invalid && eventForm.get('takeQuestions')?.touched) || missingFields.includes('How Will You Take Questions')" class="text-error">
          How Will You Take Questions is required.
        </div>
      </div>
    </div>
    <!-- Is Video On Demand Needed -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event'">
      <label class="form-label">Is Video On Demand Needed?</label>
      <div class="input-column">
        <mat-radio-group formControlName="isVideoOnDemandNeeded" class="radio-inline">
          <mat-radio-button value="Yes">Yes</mat-radio-button>
          <mat-radio-button value="No">No</mat-radio-button>
        </mat-radio-group>
        <div class="more-info">Is a replay of this live event needed?</div>
      </div>
    </div>

    <!-- VOD Expiration Date -->
    <div class="form-group" *ngIf="eventForm.get('isVideoOnDemandNeeded')?.value === 'Yes' || eventForm.get('requestType')?.value == 'Recording'">
      <label for="vodExpirationDate" class="form-label">VOD Expiration Date *</label>
      <div class="input-column">
        <div class="date-row">

          <input matInput [matDatepicker]="vodDatePicker" id="vodExpirationDate" formControlName="vodExpirationDate" class="input-field"/>
          <mat-datepicker-toggle matSuffix [for]="vodDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #vodDatePicker></mat-datepicker>
        </div>
        <div class="more-info">This is the date that the video will no longer be available for viewing. Default is 1
          year.</div>
        <div *ngIf="(eventForm.get('vodExpirationDate')?.invalid && eventForm.get('vodExpirationDate')?.touched) || missingFields.includes('VOD Expiration Date')" class="text-error">
          If VOD is needed, Expiration Date is required.
        </div>
      </div>
    </div>

    <!-- Retention Time -->
    <div class="form-group" *ngIf="eventForm.get('isVideoOnDemandNeeded')?.value === 'Yes' || eventForm.get('requestType')?.value == 'Recording'">
      <label for="retentionTime" class="form-label">Retention Time *</label>
      <div class="input-column">
        <!-- <mat-form-field appearance="fill" class="form-control"> -->
          <select formControlName="retentionTime" class="form-control input-field input-field-select" (change)="onRetentionTimeChange()">
            <option value="1 Year">1 Year</option>
            <option value="2 Years">2 Years</option>
            <option value="3 Years">3 Years</option>
            <option value="Does not need to be retained">Does not need to be retained</option>
          </select>
        <!-- </mat-form-field> -->
        <div class="more-info">How long does GM need to retain this video? This will automatically update the VOD Expiration Date.</div>
        <div *ngIf="(eventForm.get('retentionTime')?.invalid && eventForm.get('retentionTime')?.touched) || missingFields.includes('Retention Time')" class="text-error">
          Retention Time is required.
        </div>
      </div>
    </div>

    <!-- Data Classification -->
    <div class="form-group" *ngIf="eventForm.get('requestType')?.value == 'Live Event' || eventForm.get('requestType')?.value == 'Recording'">
      <label for="dataClassification" class="form-label">Data Classification *</label>
      <div class="input-column">
        <!-- <mat-form-field appearance="fill" class="form-control"> -->
          <!-- <mat-label>Select Data Classification</mat-label> -->
          <select formControlName="dataClassification" class="form-control input-field input-field-select">
            <option *ngFor="let classification of dataClassifications" [value]="classification">
              {{ classification }}
            </option>
          </select>
        <!-- </mat-form-field> -->
        <div class="more-info">Select one. <a href="https://link.gm.com/dataclass" target="_blank">Learn more</a> about Acceptable Use Guidelines.</div>
        <div *ngIf="(eventForm.get('dataClassification')?.invalid && eventForm.get('dataClassification')?.touched) || missingFields.includes('Data Classification')" class="text-error">
          Data Classification is required.
        </div>
      </div>
    </div>



    <!-- Admin Stuff! -->
    <div *ngIf="user.isAdmin && (eventForm.get('requestType')?.value == 'Live Event' || eventForm.get('requestType')?.value == 'Recording')">
      <h3>Broadcast Detail</h3>
    </div>

    <div *ngIf="user.isAdmin">
      <!-- Assigned To -->
      <div class="form-group">
        <label for="assignedTo" class="form-label">Assigned To</label>
        <div class="input-column">
          <select formControlName="assignedTo" class="form-control input-field input-field-select">
            <option value="">Select Admin</option>
            <option *ngFor="let admin of allAdmins" [value]="admin.email || admin.gmid">
              {{ admin.name || admin.email || admin.gmid }}
            </option>
          </select>
          <div class="more-info">Assign this request to a specific admin.</div>
        </div>
      </div>
    </div>
    
    <div *ngIf="user.isAdmin && (eventForm.get('requestType')?.value == 'Live Event' || eventForm.get('requestType')?.value == 'Recording')">

      <!-- Tech -->
      <div class="form-group">
        <label for="tech" class="form-label">Tech</label>
        <div class="input-column">
          <mat-form-field appearance="outline" class="form-control">
            <mat-label>Select Tech Admins</mat-label>
            <mat-select formControlName="tech" multiple>
              <mat-option *ngFor="let admin of allAdmins" [value]="admin.email || admin.gmid">
                {{ admin.name || admin.email || admin.gmid }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="more-info">Select multiple admins for tech support.</div>
        </div>
      </div>

      <!-- High Profile Event -->
      <div class="form-group">
        <label class="form-label">High Profile Event</label>
        <div class="input-column">
          <mat-radio-group formControlName="highProfileEvent" class="radio-inline">
            <mat-radio-button value="Yes">Yes</mat-radio-button>
            <mat-radio-button value="No">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <!-- Captioning -->
      <div class="form-group">
        <label class="form-label">Captioning</label>
        <div class="input-column">
          <mat-radio-group formControlName="captioning" class="radio-inline">
            <mat-radio-button value="Yes">Yes</mat-radio-button>
            <mat-radio-button value="No">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <!-- Work Related Event -->
      <div class="form-group">
        <label class="form-label">Work Related Event</label>
        <div class="input-column">
          <mat-radio-group formControlName="workRelatedEvent" class="radio-inline">
            <mat-radio-button value="Yes">Yes</mat-radio-button>
            <mat-radio-button value="No">No</mat-radio-button>
          </mat-radio-group>
          <div class="more-info">Select  No for time off, Vacation, Holiday, Jury Duty, Medical, Multiday events, etc...  This will help with filtering</div>
        </div>
      </div>

      <!-- Testing -->
      <div class="form-group">
        <label class="form-label">Testing</label>
        <div class="input-column">
          <mat-radio-group formControlName="testing" class="radio-inline">
            <mat-radio-button value="Yes">Yes</mat-radio-button>
            <mat-radio-button value="No">No</mat-radio-button>
          </mat-radio-group>
          <div class="more-info">Select YES if Used for Testing, rehearsals, Walk thrus & dry runs</div>
        </div>
      </div>

      <!-- Tools To Be Used -->
      <div class="form-group">
        <label for="toolsToBeUsed" class="form-label">Tools To Be Used</label>
        <div class="input-column">
          <div class="tools-grid">
            <div class="tools-group" *ngFor="let group of toolGroups; trackBy: trackByToolGroup">
              <div class="tools-checkbox-parent">
                <mat-checkbox [formControlName]="group.parent.key" (change)="updateMultiField(toolsOptions, 'toolsToBeUsed', 'SpecifyYourOwnValueTools', 'toolsOther')">
                  {{ group.parent.value }}
                </mat-checkbox>
              </div>
              <div *ngFor="let child of group.children; trackBy: trackByOptionKey" class="tools-checkbox-indented">
                <mat-checkbox [formControlName]="child.key" (change)="updateMultiField(toolsOptions, 'toolsToBeUsed', 'SpecifyYourOwnValueTools', 'toolsOther')">
                  {{ child.value }}
                </mat-checkbox>
              </div>
            </div>
          </div>
          
          <div class="tools-checkbox-normal">
            <mat-checkbox formControlName="SpecifyYourOwnValueTools" (change)="updateMultiField(toolsOptions, 'toolsToBeUsed', 'SpecifyYourOwnValueTools', 'toolsOther')">
              Specify your own value
            </mat-checkbox>
          </div>
          
          <div *ngIf="eventForm.get('SpecifyYourOwnValueTools')?.value" class="tools-checkbox-indented">
            <input type="text" formControlName="toolsOther" class="form-control input-field" 
                  placeholder="Specify your own tools" (input)="updateMultiField(toolsOptions, 'toolsToBeUsed', 'SpecifyYourOwnValueTools', 'toolsOther')" />
          </div>
        </div>
      </div>

      <!-- Billing Code -->
      <div class="form-group">
        <label for="programCode" class="form-label">Billing Code</label>
        <div class="input-column">
          <input type="text" id="programCode" formControlName="programCode" class="form-control input-field"
            placeholder="Enter billing code" />
          <div class="more-info">Enter the billing code for this event.</div>
        </div>
      </div>

      <!-- Cust# -->
      <div class="form-group">
        <label for="custNumber" class="form-label">Cust#</label>
        <div class="input-column">
          <select formControlName="custNumber" class="form-control input-field input-field-select">
            <option value="">Select Customer Number</option>
            <option *ngFor="let val of custNumberOptions" [value]="val">{{ val }}</option>
          </select>
          <div class="more-info">Select the customer number for this event.</div>
        </div>
      </div>

      <!-- Studio Needs -->
      <div class="form-group">
        <label for="studioNeeds" class="form-label">Studio Needs</label>
        <div class="input-column">
          <textarea id="studioNeeds" formControlName="studioNeeds" rows="6"
            class="form-control input-field" style="height: auto;" placeholder="Enter studio needs"></textarea>
          <div class="more-info">Describe any specific studio requirements or needs.</div>
        </div>
      </div>

      <!-- Broadcast Comments -->
      <div class="form-group">
        <label for="broadcastComments" class="form-label">Broadcast Comments</label>
        <div class="input-column">
          <textarea id="broadcastComments" style="height: auto;" formControlName="broadcastComments" rows="4"
            class="form-control input-field" placeholder="Enter broadcast comments"></textarea>
          <div class="more-info">Additional comments or notes about the broadcast.</div>
        </div>
      </div>

      <!-- GM Video URL -->
      <div class="form-group">
        <label for="gmVideoUrl" class="form-label">GM Video URL</label>
        <div class="input-column">
          <div class="url-field">
            <input type="text" id="gmVideoUrl" formControlName="gmVideoUrl" class="input-field form-url"
              placeholder="Enter GM Video URL" />
            <button class="open-url-btn" type="button" aria-label="Open GM Video URL"
              [disabled]="!eventForm.get('gmVideoUrl')?.value"
              (click)="openLinkInNewTab(eventForm.get('gmVideoUrl')?.value)">Open</button>
          </div>
          <div class="more-info">URL for GM Video platform.</div>
        </div>
      </div>

      <!-- Virtual Events URL -->
      <div class="form-group">
        <label for="virtualEventsUrl" class="form-label">Virtual Events URL</label>
        <div class="input-column">
          <div class="url-field">
            <input type="text" id="virtualEventsUrl" formControlName="virtualEventsUrl" class="form-url input-field"
              placeholder="Enter Virtual Events URL" />
            <button class="open-url-btn" type="button" aria-label="Open Virtual Events URL"
              [disabled]="!eventForm.get('virtualEventsUrl')?.value"
              (click)="openLinkInNewTab(eventForm.get('virtualEventsUrl')?.value)">Open</button>
          </div>
          <div class="more-info">URL for Virtual Events platform.</div>
        </div>
      </div>

      <!-- BrightCove URL -->
      <div class="form-group">
        <label for="brightcoveUrl" class="form-label">BrightCove URL</label>
        <div class="input-column">
          <div class="url-field">
            <input type="text" id="brightcoveUrl" formControlName="brightcoveUrl" class="form-url input-field"
              placeholder="Enter BrightCove URL" />
            <button class="open-url-btn" type="button" aria-label="Open BrightCove URL"
              [disabled]="!eventForm.get('brightcoveUrl')?.value"
              (click)="openLinkInNewTab(eventForm.get('brightcoveUrl')?.value)">Open</button>
          </div>
          <div class="more-info">URL for BrightCove platform.</div>
        </div>
      </div>

      <!-- Teams URL -->
      <div class="form-group">
        <label for="teamsUrl" class="form-label">Teams URL</label>
        <div class="input-column">
          <div class="url-field">
            <input type="text" id="teamsUrl" formControlName="teamsUrl" class="form-url input-field"
              placeholder="Enter Teams URL" />
            <button class="open-url-btn" type="button" aria-label="Open Teams URL"
              [disabled]="!eventForm.get('teamsUrl')?.value"
              (click)="openLinkInNewTab(eventForm.get('teamsUrl')?.value)">Open</button>
          </div>
          <div class="more-info">URL for Teams meeting or event.</div>
        </div>
      </div>

      <!-- Video Edit Section -->
      <h3>Video Edit</h3>

      <!-- Send to Archive -->
      <div class="form-group">
        <label class="form-label">Send to Archive</label>
        <div class="input-column">
          <mat-radio-group formControlName="sendToArchive" class="radio-inline">
            <mat-radio-button value="Yes">Yes</mat-radio-button>
            <mat-radio-button value="No">No</mat-radio-button>
          </mat-radio-group>
          <div class="more-info">Video to be Archived</div>
        </div>
      </div>

      <!-- Caption Editor -->
      <!-- <div class="form-group">
        <label for="captionEditor" class="form-label">Caption Editor</label>
        <div class="input-column">
          <select formControlName="captionEditor" class="form-control input-field input-field-select">
            <option value="">Select Editor</option>
            <option *ngFor="let admin of allAdmins" [value]="admin.email || admin.gmid">
              {{ admin.name || admin.email || admin.gmid }}
            </option>
          </select>
          <div class="more-info">Admin assigned to caption editing.</div>
        </div>
      </div> -->
      <div class="form-group">
        <label for="captionEditor" class="form-label">Caption Editor</label>
        <div class="input-column">
          <!-- Input mode -->
          <ng-container *ngIf="!isCaptionEditorLinkVisible; else captionEditorLinkTemplate">
            <input matInput
                   type="text"
                   id="captionEditor"
                   formControlName="captionEditor"
                   class="form-control input-field"
                   (keydown.enter)="searchCaptionEditor()"
                   placeholder="Enter caption editor's email" />
            <div class="more-info">Admin assigned to caption editing. Press Enter to search.</div>
          </ng-container>

          <!-- Link / profile mode -->
          <ng-template #captionEditorLinkTemplate>
            <div class="requestor-link-container">
              <img *ngIf="captionEditorPicture" [src]="captionEditorPicture" alt="Caption Editor Picture" class="requestor-picture"/>
              <a [href]="captionEditorLink" target="_blank">{{ captionEditorName || eventForm.get('captionEditor')?.value }}</a>
              <button *ngIf="isEditing" type="button" class="btn btn-link clear-button" (click)="clearCaptionEditor()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div class="more-info">Caption editor loaded. Clear to change.</div>
          </ng-template>
        </div>
      </div>

      <!-- Video Editing Assigned To -->
      <!-- <div class="form-group">
        <label for="videoEditingAssignedTo" class="form-label">Video Editing Assigned To</label>
        <div class="input-column">
          <select formControlName="videoEditingAssignedTo" class="form-control input-field input-field-select">
            <option value="">Select Admin</option>
            <option *ngFor="let admin of allAdmins" [value]="admin.email || admin.gmid">
              {{ admin.name || admin.email || admin.gmid }}
            </option>
          </select>
          <div class="more-info">Admin assigned to video editing tasks.</div>
        </div>
      </div> -->
      <div class="form-group">
        <label for="videoEditingAssignedTo" class="form-label">Video Editor</label>
        <div class="input-column">
          <!-- Input mode -->
          <ng-container *ngIf="!isVideoEditorLinkVisible; else videoEditorLinkTemplate">
            <input matInput
                   type="text"
                   id="videoEditingAssignedTo"
                   formControlName="videoEditingAssignedTo"
                   class="form-control input-field"
                   (keydown.enter)="searchVideoEditor()"
                   placeholder="Enter video editor's email" />
            <div class="more-info">Search and assign a video editor (press Enter).</div>
          </ng-container>

          <!-- Link mode -->
          <ng-template #videoEditorLinkTemplate>
            <div class="requestor-link-container">
              <a [href]="videoEditorLink" target="_blank">{{ videoEditorName || eventForm.get('videoEditingAssignedTo')?.value }}</a>
              <button *ngIf="isEditing" type="button" class="btn btn-link clear-button" (click)="clearVideoEditor()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div class="more-info">Video editor loaded. Clear to change.</div>
          </ng-template>
        </div>
      </div>

      <!-- Metric Edit Section -->
      <h3>Metric Edit</h3>

      <div class="metric-grid">
        <div class="metric-item">
          <label for="gmVideoAttendees" class="metric-label">GM Video Attendees</label>
          <input type="number" id="gmVideoAttendees" formControlName="gmVideoAttendees" class="form-control input-field number"/>
          <div class="metric-help">GM Video platform.</div>
        </div>
        <div class="metric-item">
          <label for="venueAttendees" class="metric-label">Venue Attendees</label>
          <input type="number" id="venueAttendees" formControlName="venueAttendees" class="form-control input-field number"/>
          <div class="metric-help">In-person venue attendees.</div>
        </div>
        <div class="metric-item">
          <label for="brightcoveAttendees" class="metric-label">Brightcove Attendees</label>
          <input type="number" id="brightcoveAttendees" formControlName="brightcoveAttendees" class="form-control input-field number"/>
          <div class="metric-help">Brightcove platform.</div>
        </div>
        <div class="metric-item">
          <label for="virtualEventsAttendees" class="metric-label">Virtual Events Attendees</label>
          <input type="number" id="virtualEventsAttendees" formControlName="virtualEventsAttendees" class="form-control input-field number"/>
          <div class="metric-help">Virtual Events platform.</div>
        </div>
        <div class="metric-item">
          <label for="teamsAttendees" class="metric-label">Teams Attendees</label>
          <input type="number" id="teamsAttendees" formControlName="teamsAttendees" class="form-control input-field number"/>
          <div class="metric-help">Teams platform.</div>
        </div>
        <div class="metric-item">
          <label for="socialMediaAttendees" class="metric-label">Social Media Attendees</label>
          <input type="number" id="socialMediaAttendees" formControlName="socialMediaAttendees" class="form-control input-field number"/>
          <div class="metric-help">Social platforms.</div>
        </div>
        <div class="metric-item">
          <label for="audioConferenceAttendees" class="metric-label">Audio Conference Attendees</label>
          <input type="number" id="audioConferenceAttendees" formControlName="audioConferenceAttendees" class="form-control input-field number"/>
          <div class="metric-help">Audio conference.</div>
        </div>
        <div class="metric-item">
          <label for="gmvcRoomCount" class="metric-label">GMVC Room Count</label>
          <input type="number" id="gmvcRoomCount" formControlName="gmvcRoomCount" class="form-control input-field number"/>
          <div class="metric-help">GMVC rooms used.</div>
        </div>
      </div>

      <!-- Studio Services Used -->
      <div class="form-group">
        <label class="form-label">Studio Services Used</label>
        <div class="input-column">
          <mat-radio-group formControlName="studioServicesUsed" class="radio-inline">
            <mat-radio-button value="Yes">Yes</mat-radio-button>
            <mat-radio-button value="No">No</mat-radio-button>
          </mat-radio-group>
          <div class="more-info">Were studio services used for this event?</div>
        </div>
      </div>

    </div>
  </form>

  <div *ngIf="showAgreement && creatingNewEvent" class="agreement-overlay">
    <div class="agreement-modal">
      <h2>Copyright Statement</h2>
      <p>By submitting a request, you agree that you will comply with the GM Copyright policy. <strong>No copyrighted images, videos, or audio are permitted</strong></p>
      <div class="agreement-actions">
        <button class="btn btn-primary" (click)="agreeToTerms()">Agree</button>
        <button class="btn btn-secondary" (click)="cancelAgreement()">Cancel</button>
      </div>
    </div>
  </div>
</div>
